









































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { EvalSettingSimple } from '@/models/evalSetting/eval-setting-simple';
import GOptionalIcon from '@/components/GOptionalIcon.vue';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting, UpdateExamineeStudentsResult } from '@/models/evalSetting/eval-setting';
import { GEnum } from '@/constants/enum.defination';
import { GPageBase } from '@/mixins';
import { ReportZipUrl } from '@/models/evalSetting/report-zip-url';
import { StringUtils } from '@/utils/string.utils';
import { EvalSettingMailToggleResponse } from '@/models/evalSetting/eval-setting-mail';
import { EnvUtils } from '@/utils/env.utils';

@Component({
  name: 'GExamListActionIcons',
  components: { GOptionalIcon },
  computed: {},
  methods: {},
})
export default class GExamListActionIcons extends Mixins(GPageBase) {
  @Prop() evalSettingSimple: EvalSettingSimple;
  @Prop({ default: 24 }) size: number;
  mounted() {}

  // メール設定の ON OFF 更新操作完了時のモーダル
  toggleMailSettingModal: boolean = false;
  toggleMailSettingResultMessage: string = "";

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isBeforeEnd(): boolean {
    return this.evalSettingSimple.isBeforeEnd;
  }

  // feature flag AIGROW2-518 teacher mail
  get isFeatureFlagTeacherMail(): boolean {
    return EnvUtils.getBoolean("VUE_APP_FEATURE_FLAG_GIFT_COURSE_MAIL")
  }

  deleteEvalSetting(evalSettingID: number) {
    evalSettingModule.deleteEvalSettingDetail(evalSettingID);
  }

  handleGetZipReportDownload() {
    this.isRunning = true;
    evalSettingModule.getZipReportDownload(this.evalSettingSimple.evalSettingID).then((reportZipUrl: ReportZipUrl) => {
      this.isRunning = false;
      window.open(reportZipUrl.url, '_self');
    });
  }

  handleGetSimpleZipReportDownload() {
    this.isRunning = true;
    evalSettingModule.getSimpleZipReportDownload(this.evalSettingSimple.evalSettingID).then((reportZipUrl: ReportZipUrl) => {
      this.isRunning = false;
      const baseUrl = StringUtils.getBaseUrlFromFullPath(reportZipUrl.simpleZipURL);
      if (StringUtils.isValidSimpleZipUrl(baseUrl)) {
        window.open(reportZipUrl.simpleZipURL, '_self');
      } else {
        this.showNotice(GEnum.MessageType.Error, this.$t('ERROR').toString(), this.$t('NOTICE_NOT_CREATED_FEEDBACK_REPORT').toString(), 10);
      }
    });
  }

  handleGotoExamEdit() {
    this.$router.push(`/pages/exam/create?mode=${GEnum.EvalSettingMode.Edit}&evalSettingID=${this.evalSettingSimple.evalSettingID}`);
  }

  handleGotoExamCopy() {
    this.$router.push(`/pages/exam/create?mode=${GEnum.EvalSettingMode.Copy}&evalSettingID=${this.evalSettingSimple.evalSettingID}`);
  }

  handleUpdateExamineeStudents() {
    this.isRunning = true;
    evalSettingModule.updateExamineeStudents(this.evalSettingSimple.evalSettingID).then((response: UpdateExamineeStudentsResult) => {
      this.isRunning = false;
      if (response.updatedCount > 0) {
        this.showNotice(GEnum.MessageType.Success, this.$t('EVAL_COURSE').toString() + `【${this.evalSettingSimple.title}】`, this.$t('MESSAGE_UPDATE_STUDENTS_BY_CLASS_UPDATE', {value: response.updatedCount}).toString());
      } else {
        this.showNotice(GEnum.MessageType.Success, this.$t('EVAL_COURSE').toString() +`【${this.evalSettingSimple.title}】`, this.$t('MESSAGE_NO_STUDENTS_BY_CLASS_UPDATE').toString());
      }
    });
  }

  handleDeleteConfirm() {
    let config = {
      title: this.$t('EVAL_COURSE').toString() + this.$t('CONFIRM_DELETE_X', {value: this.evalSettingSimple.title}).toString(),
      onOk: () => {
        this.loadingPage(
          () => {
            this.deleteEvalSetting(this.evalSettingSimple.evalSettingID);
          },
          () => {
            this.showDeleteSuccessed();
            window.location.reload();
          }
        );
      },
      onCancel: () => {
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  handleFileDownloadButtonClick() {
    this.isRunning = true;
    evalSettingModule.downloadProgress(this.evalSettingSimple).then(() => {
      this.isRunning = false;
    });
  }

  handleToggleMailSetting() {
    // 受検編集のメール設定へ遷移する
    this.$router.push({
      name: 'exam-create',
      query: {
        evalSettingID: this.evalSettingSimple.evalSettingID,
        mode: GEnum.EvalSettingMode.Edit,
        step: GEnum.ExamCreateStep.MailSettingStep,
      }
    } as any);
    /*
    メール機能の ON OFF 切り替え
    this.isRunning = true;
    evalSettingModule.toggleMailSetting(this.evalSettingSimple.evalSettingID).then((res: EvalSettingMailToggleResponse) => {
      this.isRunning = false;
      if (res.result) {
        // 有効だった状態から更新した結果は無効になるので「無効にしました」を表示
        this.toggleMailSettingResultMessage = this.evalSettingSimple.mailSetting.mailEnable ? this.$t(`EXAM_MAIL_SETTING_UPDATE_DISABLED`).toString() : this.$t(`EXAM_MAIL_SETTING_UPDATE_ENABLED`).toString();
        this.evalSettingSimple.mailSetting.mailEnable = !this.evalSettingSimple.mailSetting.mailEnable;
      } else {
        this.toggleMailSettingResultMessage = this.$t(`GROW_API_ERROR_MESSAGE_CODE.${res.errType}`).toString();
      }
      this.toggleMailSettingModal = true;
    });
    */
  }

  handleCloseToggleMailSettingModal() {
    this.toggleMailSettingModal = false;
  }
}
